import {
  SET_PRODUCT,
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING
} from './product.constants';


const initialState = {
  briefs: [{
    "country": "Germany",
    updatedAt: "2026-04-22T12:00:00Z",
    createdAt: "2026-04-20T13:00:00Z",
    "brifs": [
        {
            "description": "Life’s meaningful milestones are made to be celebrated and shared with loved ones. Design mobile-first WhatsApp cards that help users mark anniversaries, weddings, growing families, school achievements, and other special moments with warmth and joy. Combine heartfelt messaging, cheerful visuals, and easy-to-share layouts so every card feels personal, polished, and ready to send.",
            "earn": "Earn US$20",
            "info": [
                {
                    "description": "23 days left",
                    "title": "May 15, 2026 9:59 AM"
                },
                {
                    "description": "US$20",
                    "title": "Payment per accepted submission"
                },
                {
                    "description": "15 submissions remaining",
                    "title": "Maximum 15 submissions per Creator"
                }
            ],
            "title": "Milestones Celebration WhatsApp Cards"
        },
        {
            "description": "",
            "earn": "Earn US$20",
            "info": [
                {
                    "description": "9 days left",
                    "title": "May 1, 2026 9:59 AM"
                },
                {
                    "description": "US$20",
                    "title": "Payment per accepted submission"
                }
            ],
            "title": "Condolences & Well Wishes WhatsApp Card"
        }
    ],
    "opportunities": [
        {
            "description": "Suchanfragen zeigen eine hohe Nachfrage nach Collage-Videos im Frühlingsdesign und Clips für Frühlings-Geburtstagseinladungen. Allerdings fehlen im Bestand Vorlagen für Instagram Stories mit saisonalen Collagen-Layouts.",
            "rank": "1",
            "theme": "Mobile Video",
            "title": "Frühlings-Collage Instagram Story für Geburtstags-Einladungen",
            "url": "https://www.canva.com/design/DAHHgAdZK5g/muauq0MzbsdZUYTEkWYhtA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchvolumen für Instagram-Feed-Layouts und 6-Foto-Collagen mangelt es an passenden Vorlagen. Erstellen Sie modulare Instagram-Feed-Gittervorlagen, die Bilder über mehrere Posts verteilen.",
            "rank": "2",
            "theme": "Your Story",
            "title": "6er Collage Instagram-Raster",
            "url": "https://www.canva.com/design/DAHHgLyF0uM/2My4QhWH1Ami7m0Ev5UyTg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchinteresse an minimalistischen, ästhetischen Vorlagen für Pitch Decks und Business-Präsentationen; Erstellung von klaren, modernen Pitch Decks für Startups, Vertrieb und Produktpräsentationen.",
            "rank": "3",
            "theme": "Presentation",
            "title": "Minimales Pitch Deck Präsentation",
            "url": "https://www.canva.com/design/DAHHgE8jdoY/GVbgi8CMAsuNRtpVyMaPWA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchvolumen für Weihnachtsplakate mit Schneemann, Nikolaus und Frohe Weihnachten, aber es gibt nur wenige lokalisierte Designs – erstelle festliche Plakate mit diesen Motiven.",
            "rank": "4",
            "theme": "Poster",
            "title": "Weihnachtsfeier-Poster",
            "url": "https://www.canva.com/design/DAHHgE5Vt2M/BJzzKcSRaS_bOUfHPm9twQ/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Suchdaten zeigen eine hohe Nachfrage nach faltbaren Flyern mit mehreren Seiten und abtrennbaren Elementen für Veranstaltungen. Die Poster-Bibliothek bietet jedoch keine entsprechenden Layouts. Erstellen Sie daher Vorlagen für Flyer mit mehreren Seiten und abtrennbaren Elementen.",
            "rank": "5",
            "theme": "Poster",
            "title": "Faltbare Flyer-Poster",
            "url": "https://www.canva.com/design/DAHHgMVwPrQ/jiTETeS_wKyc59zxUDTJiQ/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Suchen zeigen eine starke Nachfrage nach romantischen Jubiläums-Instagram-Stories und Collagen, aber die Bibliothek bietet keine lokalisierten Love-Collage-Story-Designs für Paare.",
            "rank": "6",
            "theme": "Your Story",
            "title": "Romantische Jubiläums-Collage Instagram Story",
            "url": "https://www.canva.com/design/DAHHgLAJBi0/3kkX0iMoL-xKmvJ2qkcOwg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Starkes Interesse an Schlitten-Bucket-Lists für Freundesausflüge; Erstellen Sie teilbare Vorlagen für Winteraktivitäten mit Rodelbahnen, Gruppenherausforderungen, lokalen Orten und Sicherheitstipps.",
            "rank": "7",
            "theme": "Your Story",
            "title": "Schlittenfahren Bucket List Instagram Story",
            "url": "https://www.canva.com/design/DAHHgI0OEhc/adzu-46sBqmTUxfONeYFgQ/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Nutzer suchen nach Präsentationen und Handouts für Unterrichtsstunden, aber die Bibliothek bietet kaum bearbeitbare Folienvorlagen, um den Unterrichtsfluss und Klassenaktivitäten zu unterstützen.",
            "rank": "8",
            "theme": "Presentation",
            "title": "Englischunterricht Präsentation für Lehrkräfte",
            "url": "https://www.canva.com/design/DAHHgCH7i90/MtCMrGfvItsW3_p8ZkmVPw/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Das Suchinteresse an Robotik, KI und futuristischen Tech-Postern übersteigt das Angebot an verfügbaren Designs. Erstellen Sie kühne, futuristische Poster-Vorlagen für Robotik und künstliche Intelligenz.",
            "rank": "9",
            "theme": "Poster",
            "title": "Poster für Robotik und KI",
            "url": "https://www.canva.com/design/DAHHgOT9uwc/D3-7IpWQwdrCtLiaemiA-w/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach mobilen Videos für indische Hochzeits-Einladungen, aber keine Vorlagen vorhanden; erstelle vertikale Einladungs-Videos mit kulturellen Motiven und bearbeitbarem Text in doppelter Schrift.",
            "rank": "10",
            "theme": "Mobile Video",
            "title": "Indisches Hochzeitsvideo für Mobilgeräte",
            "url": "https://www.canva.com/design/DAHHgPhRYVI/TniQQZIoTwFgrzzs1SBmeg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach Präsentationsvorlagen für Geburtstagsfeiern mit Elementen wie Zirkus, Disco und Wunschliste, jedoch fehlt es der Bibliothek an passenden Präsentationen.",
            "rank": "11",
            "theme": "Presentation",
            "title": "Geburtstagsfeier-Präsentation",
            "url": "https://www.canva.com/design/DAHHgFBeOcg/3rdktPZSGs5XH0JG5THG_w/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Steigende Suchanfragen nach Disco und Disco-Partys signalisieren eine Nachfrage nach fröhlichen Retro-Hochformat-Videos. Erstellen Sie kurze, tanzbereite Disco-Mobilvideos mit Vintage-Visuals.",
            "rank": "12",
            "theme": "Mobile Video",
            "title": "Disco-Party-Video für Mobilgeräte",
            "url": "https://www.canva.com/design/DAHHgG0oPjk/OrD4anQc2lUawDna1sLA8Q/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Analysen zeigen eine hohe Nachfrage nach Werbematerialien für den Osterverkauf, aber nur wenige Instagram-Post-Vorlagen für Flyer, Poster und Angebotskarten.",
            "rank": "13",
            "theme": "Instagram Post",
            "title": "Osterverkauf Instagram Post",
            "url": "https://www.canva.com/design/DAHHgCM-Y8w/n4taAIly-VRIuRh3mFZubw/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchvolumen für Instagram-Post-Vorlagen im Format 1080x1080 und 1080x1350, aber die Bibliothek bietet keine passenden Elemente – erstelle größenoptimierte Instagram-Posts.",
            "rank": "14",
            "theme": "Instagram Post",
            "title": "Quadratisches 1080x1080 Instagram Post",
            "url": "https://www.canva.com/design/DAHHgEZYSkU/Bb0ytbAcnjQWT8-Ey-Rx7w/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchinteresse an Instagram-Posts mit Restaurantmenüs und aktualisierten Öffnungszeiten, aber es gibt nur wenige Vorlagen – Erstellung modularer Menü- und Öffnungszeiten-Post-Layouts.",
            "rank": "15",
            "theme": "Instagram Post",
            "title": "Menü und Öffnungszeiten Instagram Post",
            "url": "https://www.canva.com/design/DAHHgGVCPVM/nYj7e274TDip7o5usrtjPw/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Nutzer suchen nach Instagram-Posts mit Mockups von Postern und Wandkunst, die realistische Wohnzimmer-Darstellungen und Rahmenvarianten zeigen, aber passende Designs fehlen.",
            "rank": "16",
            "theme": "Instagram Post",
            "title": "Mockup für Wandkunst Instagram Post",
            "url": "https://www.canva.com/design/DAHHgIKhyMk/MuPVrNLP-Z8J7bOx6UGulg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Suchdaten zeigen eine hohe Nachfrage nach mobilen Einladungsvideos, aber nur wenige vertikale Vorlagen für Hochzeits-, Geburtstags-, Unternehmens- und Sommerfesteinladungen.",
            "rank": "17",
            "theme": "Mobile Video",
            "title": "Einladungs-Video Instagram Story",
            "url": "https://www.canva.com/design/DAHHgG1sH-A/aWufQdgGJgEW4bp8kNU6Bg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Nutzer suchen auf Instagram nach informativen Postern und Aushängen für dringende Community- oder Geschäftsaktualisierungen, aber es fehlen Vorlagen.",
            "rank": "18",
            "theme": "Instagram Post",
            "title": "Wichtige Informationen Instagram Post",
            "url": "https://www.canva.com/design/DAHHgM01v8k/F5NhNnnbJjkMeuxgYWw7xA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe lokale Nachfrage nach Geburtstags-Einladungen – alterspezifisch (16, 18, 30) und Themen wie Neon, Gold, Einhorn, Pastell und BBQ – mit wenigen Optionen für Instagram Posts.",
            "rank": "19",
            "theme": "Instagram Post",
            "title": "Geburtstagseinladungen Instagram Post",
            "url": "https://www.canva.com/design/DAHHgMBFbLI/Lkm_l2dOScBMtYciwSFb1Q/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach kurzen Pasta- und Spaghetti-Mobilvideos für Rezepte und Pasta-Party-Promotionen; Erstellen Sie snackable, lokalisierte Pasta-Rezept- und Party-Clips.",
            "rank": "20",
            "theme": "Mobile Video",
            "title": "Nudeln Party mobile Video",
            "url": "https://www.canva.com/design/DAHHgMLIPrc/uoeojkOp9o9BE5TilqCfpA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchinteresse an „Medizin“ und verwandten Anfragen. Es fehlen Instagram-Post-Vorlagen für medizinische Dienstleistungen für Kliniken, Apotheken und Ärzte. Erstellen Sie Beiträge, die Dienstleistungen, Impfungen und Öffnungszeiten abdecken.",
            "rank": "21",
            "theme": "Instagram Post",
            "title": "Instagram Post für medizinische Dienstleistungen",
            "url": "https://www.canva.com/design/DAHHgBD0SnI/J7muaavO3qcOFlOi8p3fqw/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach Plakaten für Frühlingsfeste und Open-Air-Veranstaltungen; Erstellung von saisonalen Floral-Poster- und Einladungsvorlagen für Märkte, Vereine und Community-Events",
            "rank": "22",
            "theme": "Poster",
            "title": "Frühlings-Event-Poster für Gemeinde-Events",
            "url": "https://www.canva.com/design/DAHHgPW_-6E/z9GyRKk8CyNtznFKcdCCPA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Suchanfragen nach Postern mit Fischen und Meereslebewesen (Häfen, Muscheln, Aquarien), aber wenige verfügbare Posterdesigns mit maritimen und Aquarium-Themen.",
            "rank": "23",
            "theme": "Poster",
            "title": "Poster mit Meeresleben",
            "url": "https://www.canva.com/design/DAHHgOVvVTs/pB93ygcNhrtBzIvGTFvoVA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Suchanfragen für Club-, Disco- und Cocktailparty-Visuals – 80er-Jahre-Retro, Discokugeln, DJ-Sets, Sommergarten und White-Party-Themen – dennoch sind Instagram-Post-Vorlagen rar.",
            "rank": "24",
            "theme": "Instagram Post",
            "title": "Club und Disco Party Instagram Post",
            "url": "https://www.canva.com/design/DAHHgONL9EI/49k_afbke4gN-4vqgbeWtA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach Instagram-Rezeptkarten-Vorlagen mit Zutatenlisten und Schritt-für-Schritt-Anleitungen, aber die Bibliothek weist keine Instagram-Post-Designs auf, um den Suchanfragen gerecht zu werden.",
            "rank": "25",
            "theme": "Instagram Post",
            "title": "Rezeptkarten-Instagram-Post",
            "url": "https://www.canva.com/design/DAHHgLp7iSM/Z7a65No1nAtzv45hKenbCg/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohe Nachfrage nach Instagram Story-Produktanzeigen und Mini-Katalogen. Erstellen Sie vertikale Story-Vorlagen für Produkteinführungen, Aktionen und Katalog-ähnliche Folien.",
            "rank": "26",
            "theme": "Your Story",
            "title": "Produktwerbung Instagram Story",
            "url": "https://www.canva.com/design/DAHHgNKen40/s7ZVL6k89ZvBuTwxBHGzKA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Suchanfragen zeigen eine hohe Nachfrage nach Gutschein-Visuals, aber es gibt nur wenige Instagram Story-Vorlagen; erstellen Sie anpassbare Gutschein-Story-Designs für Dienstleistungen, Einzelhandel und Erlebnisse.",
            "rank": "27",
            "theme": "Your Story",
            "title": "Gutschein Instagram Story",
            "url": "https://www.canva.com/design/DAHHgNIv79w/xkx6x56fyZvqAEFb11CE6g/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Suchen zeigen hohe Nachfrage nach Exposé-Fotos und Instagram-Posts für Miete/Verkauf, aber passende Layouts für Objekt-Posts fehlen – erstellen Sie fotofokussierte Objekt-Posts.",
            "rank": "28",
            "theme": "Instagram Post",
            "title": "Immobilien-Exposé Instagram Post",
            "url": "https://www.canva.com/design/DAHHgBAjw8w/tYeRpyqyjcIFOUBxKJx91w/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Interesse an Neon-80er-Jahre- und Techno-Club-Party-Visuals – erstellen Sie auffällige Neon-Rave-Vorlagen mit DJ-Lineup-, Event-Promo- und Ladies-Night-Layouts.",
            "rank": "29",
            "theme": "Your Story",
            "title": "Neon-Techno-Party Instagram Story",
            "url": "https://www.canva.com/design/DAHHgHYZHBI/SS9D7IP2D90eyPtruZQAPA/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        },
        {
            "description": "Hohes Suchvolumen für kurze Instagram-Videos zur Vorstellung von Einzelpersonen und Teams, aber es gibt keine mobilen Video-Vorlagen, um diese Nachfrage zu bedienen.",
            "rank": "30",
            "theme": "Mobile Video",
            "title": "Vorstellung des Teams Instagram Reels",
            "url": "https://www.canva.com/design/DAHHgP5F_84/_gcPqIeLAqIR619MOH-W6g/edit?ui=eyJBIjp7IkEiOiJtYXJrZXRwbGFjZV90ZW1wbGF0ZV9hc3Npc3RhbnQifX0"
        }
    ]
}],
  briefsLoading: false,
  product: {},
  pluginInfo: {},
};

const productReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_BRIEFS: {
      return {
        ...state,
        briefs: payload,
      }
    }

    case SET_BRIEFS_LOADING: {
      return {
        ...state,
        briefsLoading: payload,
      }
    }

    case SET_PRODUCT: {
      return {
        ...state,
        product: payload,
      }
    }

    case SET_PLUGIN_INFO: {
      return {
        ...state,
        pluginInfo: payload,
      }
    }

    default:
      return state;
  }
};

export default productReducer;
